import * as $ from 'jquery';
import { OnReadyModule } from '../../lib/app-module';

export interface TabPagesConfig {
    tabSelector: string;
    contentPageSelector: string;
    activeTagClass: string;
}

export class TabPages extends OnReadyModule<TabPagesConfig> {
    protected init(): void {
        this.selectPageFromLocationHashOrDefault();        
        this.monitorTabslicks();
    }

    private selectPageFromLocationHashOrDefault(): void {
        const matchesPage = $(`${this.config.contentPageSelector}${window.location.hash}`);
        const start = matchesPage.length ? matchesPage : $(this.config.contentPageSelector).first();
        this.setActivePage(start.attr('id') ?? '');
    }

    private monitorTabslicks(): void {
        $(`${this.config.tabSelector} > a[href*=\\#]`).on('click', (event: JQuery.TriggeredEvent) => {
            const pageId = (event.target as HTMLAnchorElement).hash.slice(1);
            this.setActivePage(pageId);
        });
    }

    private setActivePage(pageId: string): void {
        let activeIndex = 0;
        $(this.config.contentPageSelector).map((index, el) => {
            if (el.id === pageId) {
                activeIndex = index;
                $(el).show();
            } else {
                $(el).hide();
            }
        });
        $(this.config.tabSelector).map((index, el) => {
            if (index === activeIndex) {
                $(el).addClass(this.config.activeTagClass);
            } else {
                $(el).removeClass(this.config.activeTagClass);
            }
        });
    }
}
